/**
 * Lage-niveau mutators, gedeeld door effects/weakness/battle. Muteren de
 * (reeds gekloonde) state in-place.
 */
import type { Status } from '../data/types';
import type { ActieveStatus, BattleState } from './state';
import { log } from './state';

/** Brengt schade toe aan de baas (HP-bazen). Bij verbindingFight: n.v.t. */
export function schadeAanBaas(state: BattleState, n: number): void {
  if (n <= 0) return;
  const bs = state.baasState;
  if (bs.baas.verbindingFight) return; // Theluun heeft geen HP
  // noBossDmg: block beschermt nog, maar doet geen schade — wordt afgevangen in
  // effects (block-pad). Directe dmg/bonus gaat hier altijd door.
  bs.hp = Math.max(0, bs.hp - n);
}

/** Past de Verbinding-meter aan (alleen relevant bij Theluun). */
export function verbinding(state: BattleState, delta: number): void {
  const bs = state.baasState;
  if (!bs.baas.verbindingFight) return;
  bs.verbinding = Math.max(0, Math.min(100, bs.verbinding + delta));
}

/** Baas verliest energie (min 0). */
export function baasEnergieVerlies(state: BattleState, n: number): void {
  if (n <= 0) return;
  state.baasState.energie = Math.max(0, state.baasState.energie - n);
}

/** Heelt de speler (cap op maxHp; respecteert nullifyHeal). */
export function heelSpeler(state: BattleState, n: number): void {
  if (n <= 0) return;
  if (heeftStatus(state, 'nullifyHeal')) {
    log(state, 'Heling geblokkeerd.');
    return;
  }
  state.speler.hp = Math.min(state.speler.maxHp, state.speler.hp + n);
}

export function heeftStatus(state: BattleState, kind: Status['kind']): boolean {
  return state.speler.statuses.some((s) => s.kind === kind && s.resterend > 0);
}

export function vindStatus(state: BattleState, kind: Status['kind']): ActieveStatus | undefined {
  return state.speler.statuses.find((s) => s.kind === kind && s.resterend > 0);
}

/** Voegt een status toe (one-shot kinds krijgen resterend=1). */
export function voegStatusToe(state: BattleState, status: Status): void {
  const oneShot = status.kind === 'reverseNext' || status.kind === 'energySteal';
  const resterend = oneShot ? 1 : status.turns ?? 1;
  // veil-immuniteit blokkeert nieuwe veil
  if (status.kind === 'veil' && (state.speler.veilImmuneTurns > 0 || state.speler.veilPermanentCleared)) {
    log(state, 'Sluier afgeweerd (immuun).');
    return;
  }
  state.speler.statuses.push({ ...status, resterend });
}

/** Verwijdert 1 (of alle) negatieve status(sen). */
export function cleanse(state: BattleState, hoeveel: 'one' | 'all'): void {
  if (state.speler.statuses.length === 0) return;
  if (hoeveel === 'all') {
    state.speler.statuses = [];
    log(state, 'Alle blokkades opgeheven.');
  } else {
    state.speler.statuses.shift();
    log(state, 'Blokkade opgeheven.');
  }
}
